<p-card>
  <p-confirmpopup></p-confirmpopup>

  <form class="new-chat-form" (ngSubmit)="createChat()" [formGroup]="newChatForm">
    <div class="new-chat-title">
      <span>Neue Unterhaltung</span>
    </div>
    <div class="new-chat-fields">
      <p-floatlabel class="recipients-field">
        <p-autoComplete inputId="recipients" inputStyleClass="w-100" class="w-100" formControlName="recipients"
          [suggestions]="users" (completeMethod)="filterUsers($event)" field="first_name" [multiple]="true">
          <ng-template let-user pTemplate="item">
            <div class="user-option">
              <app-user-avatar [user]="user" size="normal"></app-user-avatar>
              <span>{{ userName(user) }}</span>
            </div>
          </ng-template>
          <ng-template let-user pTemplate="selectedItem">
            <span>{{ userName(user) }}</span>
          </ng-template>
        </p-autoComplete>
        <label for="recipients">Empfänger</label>
      </p-floatlabel>

      <p-button type="submit" label="Chat starten" icon="pi pi-plus" [loading]="sending"
        [disabled]="newChatForm.invalid || sending">
      </p-button>
    </div>
  </form>

  <div class="messages-layout" [class.chat-open]="!!selectedChat">
    <aside class="chat-list" aria-label="Chats">
      <div class="chat-list-header">
        <h2>Chats</h2>
        @if (loading) {
        <p-progressSpinner styleClass="small-spinner" strokeWidth="4"></p-progressSpinner>
        }
      </div>

      @if (!loading && chats.length === 0) {
      <div class="empty-chat-list">
        <i class="pi pi-comments"></i>
        <span>Noch keine Chats</span>
      </div>
      }

      @for (chat of chats; track chat.id) {
      <button type="button" class="chat-list-item" [class.active]="selectedChat?.id === chat.id"
        (click)="selectChat(chat)">
        <div class="chat-avatar">
          @if (chat.type === 'group') {
          <p-avatar icon="pi pi-users" shape="circle"></p-avatar>
          } @else {
          <app-user-avatar [user]="firstOtherUser(chat)" size="normal"></app-user-avatar>
          }
        </div>
        <div class="chat-list-text">
          <div class="chat-list-title-row">
            <span class="chat-list-title">{{ chatTitle(chat) }}</span>
            @if (lastMessage(chat)) {
            <span class="chat-list-date">{{ messageDate(lastMessage(chat)) | date : 'dd.MM. HH:mm' }}</span>
            }
          </div>
          <div class="chat-list-preview-row">
            <span class="chat-list-preview">{{ lastMessagePreview(chat) }}</span>
            @if (unreadCount(chat) > 0) {
            <p-badge [value]="unreadCount(chat).toString()" severity="danger"></p-badge>
            }
          </div>
        </div>
      </button>
      }
    </aside>

    <section class="chat-panel" [class.empty]="!selectedChat">
      @if (selectedChat) {
      <header class="chat-panel-header">
        <div class="chat-panel-title">
          <p-button type="button" icon="pi pi-arrow-left" styleClass="mobile-back-button" [text]="true" [rounded]="true"
            (onClick)="closeChatOnMobile()">
          </p-button>
          @if (selectedChat.type === 'group') {
          <p-avatar icon="pi pi-users" shape="circle"></p-avatar>
          } @else {
          <app-user-avatar [user]="firstOtherUser(selectedChat)" size="normal"></app-user-avatar>
          }
          <div>
            <h2>{{ chatTitle(selectedChat) }}</h2>
            @if (selectedChat.type === 'group') {
            <span>{{ chatSubtitle(selectedChat) }}</span>
            }
          </div>
        </div>
        <p-button type="button" icon="pi pi-trash" severity="danger" styleClass="delete-chat-button" [text]="true"
          [rounded]="true" [disabled]="sending" pTooltip="Chat löschen" tooltipPosition="left"
          (onClick)="deleteChat($event, selectedChat)">
        </p-button>
      </header>

      <div class="chat-messages">
        @if (sortedMessages(selectedChat).length === 0) {
        <div class="empty-chat">
          <i class="pi pi-comment"></i>
          <span>In diesem Chat gibt es noch keine Nachrichten.</span>
        </div>
        }

        @for (message of sortedMessages(selectedChat); track message.id; let index = $index) {
        @if (showDateSeparator(message, selectedChat, index)) {
        <div class="date-separator">{{ messageDate(message) | date : 'dd.MM.yyyy' }}</div>
        }
        <div class="message-row" [class.own]="isOwnMessage(message)">
          <div class="message-bubble">
            @if (selectedChat.type === 'group' && !isOwnMessage(message)) {
            <span class="message-author">{{ userName(message.users_permissions_user) }}</span>
            }
            <span class="message-body">{{ message.body }}</span>
            <span class="message-date">
              {{ messageDate(message) | date : 'HH:mm' }}
              @if (messageReadState(message, selectedChat); as readState) {
              <span class="read-state" [class.read]="readState === 'read'"
                [attr.aria-label]="readState === 'read' ? 'Gelesen' : 'Gesendet'">
              </span>
              }
            </span>
          </div>
        </div>
        }
        <div #messagesEnd></div>
      </div>

      <form class="reply-form" (ngSubmit)="sendMessage()" [formGroup]="replyForm">
        <textarea pTextarea formControlName="message" rows="2" placeholder="Nachricht schreiben" class="reply-input"
          (keydown)="handleReplyKeydown($event)">
          </textarea>
        <p-button type="submit" icon="pi pi-send" [rounded]="true" [loading]="sending"
          [disabled]="replyForm.invalid || sending">
        </p-button>
      </form>
      } @else {
      <div class="no-chat-selected">
        <i class="pi pi-comments"></i>
        <h2>Chat auswählen</h2>
        <span>Wähle links einen Chat aus oder starte oben eine neue Unterhaltung.</span>
      </div>
      }
    </section>
  </div>
</p-card>
